module.exports = __webpack_public_path__ + "static/media/novo-menu.6a787002.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/novo-menu.svg
// module id = 147
// module chunks = 0